import { FC } from 'react';
import { IconProps } from '../types';

const CJIcon: FC<IconProps> = ({
  width = 192,
  height = 36,
  margin = 0,
  padding = 0,
  color = '',
  cursor = 'default',
  handleClick,
  opacity = '1',
  direction = 'up',
  dataTestId = 'cj-icon'
}) => {
  const directionRotation = {
    up: '0deg',
    right: '90deg',
    down: '180deg',
    left: '270deg'
  };
  return (
    <svg
      width={width}
      height={height}
      style={{ margin, padding, cursor, rotate: directionRotation[direction] }}
      viewBox='0 0 192 36'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      data-testid={dataTestId}
      data-direction={direction}
      onClick={handleClick}
    >
      <g data-testid='g-path' opacity={opacity}>
        <path
          data-testid='path-with-color'
          d='M58.0906 6.96118C62.1346 6.96118 64.204 9.1798 64.204 9.1798L63.0374 10.9472C63.0374 10.9472 61.0864 9.10856 58.1853 9.10856C54.4253 9.10856 51.9772 11.9717 51.9772 15.5541C51.9772 19.1568 54.476 22.2134 58.2089 22.2134C61.3738 22.2134 63.3958 20.0185 63.3958 20.0185L64.6571 21.7147C64.6571 21.7147 62.351 24.3879 58.1379 24.3879C53.093 24.3879 49.5494 20.5206 49.5494 15.5812C49.5494 10.686 53.2114 6.96118 58.0906 6.96118Z'
          fill={color || '#015F94'}
        />
        <path
          d='M73.8475 16.5548H74.3716V16.3411C74.3716 14.36 73.2524 13.6917 71.7308 13.6917C69.8745 13.6917 68.3765 14.862 68.3765 14.862L67.4264 13.1658C67.4264 13.1658 69.1644 11.7343 71.9235 11.7343C74.9701 11.7343 76.681 13.4067 76.681 16.4598V24.0995H74.5406V22.9529C74.5406 22.4033 74.588 21.9996 74.588 21.9996H74.5406C74.5406 21.9996 73.5668 24.3878 70.686 24.3878C68.6166 24.3878 66.5946 23.1225 66.5946 20.7105C66.5912 16.7245 71.8255 16.5548 73.8475 16.5548ZM71.183 22.522C73.134 22.522 74.3953 20.4696 74.3953 18.6785V18.2985H73.8001C72.0622 18.2985 68.9243 18.4173 68.9243 20.5884C68.9209 21.5688 69.6817 22.522 71.183 22.522Z'
          fill={color || '#015F94'}
        />
        <path
          d='M80.1941 12.0226H82.4291V14.1225C82.4291 14.6245 82.3818 15.0282 82.3818 15.0282H82.4291C82.9769 13.2608 84.3801 11.8767 86.2365 11.8767C86.5442 11.8767 86.8316 11.9242 86.8316 11.9242V14.2141C86.8316 14.2141 86.5239 14.1428 86.1655 14.1428C84.6912 14.1428 83.3353 15.1945 82.7875 16.9822C82.5745 17.6743 82.5035 18.4138 82.5035 19.1534V24.0927H80.1975V12.0226H80.1941Z'
          fill={color || '#015F94'}
        />
        <path
          d='M94.1622 11.7343C97.5638 11.7343 99.3728 14.265 99.3728 17.3928C99.3728 17.7015 99.3018 18.3969 99.3018 18.3969H90.5239C90.6423 21.0464 92.5223 22.383 94.6626 22.383C96.732 22.383 98.2299 20.9751 98.2299 20.9751L99.1801 22.6713C99.1801 22.6713 97.3947 24.3913 94.5173 24.3913C90.7336 24.3913 88.1401 21.6468 88.1401 18.0644C88.1435 14.2175 90.737 11.7343 94.1622 11.7343ZM97.016 16.6498C96.945 14.5737 95.6601 13.5695 94.1149 13.5695C92.3532 13.5695 90.9263 14.6687 90.5949 16.6498H97.016Z'
          fill={color || '#015F94'}
        />
        <path
          d='M101.253 18.4172H103.586V19.133C103.586 21.4229 104.918 22.2133 106.25 22.2133C107.559 22.2133 108.867 21.45 108.867 19.2314V9.29849H104.634V7.24609H111.224V19.2517C111.224 22.9053 108.678 24.3844 106.227 24.3844C103.775 24.3844 101.253 22.8816 101.253 19.2517V18.4172Z'
          fill={color || '#015F94'}
        />
        <path
          d='M120.702 11.7343C124.293 11.7343 127.197 14.3837 127.197 18.0339C127.197 21.7113 124.296 24.3845 120.702 24.3845C117.108 24.3845 114.207 21.7113 114.207 18.0373C114.207 14.3837 117.111 11.7343 120.702 11.7343ZM120.702 22.3796C122.984 22.3796 124.841 20.5646 124.841 18.0339C124.841 15.5269 122.984 13.7392 120.702 13.7392C118.443 13.7392 116.563 15.5303 116.563 18.0339C116.563 20.5646 118.443 22.3796 120.702 22.3796Z'
          fill={color || '#015F94'}
        />
        <path
          d='M129.899 12.0226H132.209V19.2314C132.209 20.9039 132.54 22.2405 134.467 22.2405C136.919 22.2405 138.369 20.0693 138.369 17.6811V12.0226H140.675V24.0995H138.44V22.5017C138.44 21.9996 138.488 21.6196 138.488 21.6196H138.44C137.94 22.8138 136.371 24.3878 134.014 24.3878C131.302 24.3878 129.899 22.9562 129.899 19.7572V12.0226Z'
          fill={color || '#015F94'}
        />
        <path
          d='M144.26 12.0226H146.495V14.1225C146.495 14.6245 146.447 15.0282 146.447 15.0282H146.495C147.042 13.2608 148.446 11.8767 150.302 11.8767C150.613 11.8767 150.897 11.9242 150.897 11.9242V14.2141C150.897 14.2141 150.586 14.1428 150.231 14.1428C148.757 14.1428 147.401 15.1945 146.853 16.9822C146.64 17.6743 146.569 18.4138 146.569 19.1534V24.0927H144.263V12.0226H144.26Z'
          fill={color || '#015F94'}
        />
        <path
          d='M153.247 12.0226H155.482V13.6204C155.482 14.0987 155.435 14.5024 155.435 14.5024H155.482C155.959 13.4508 157.386 11.7343 160.003 11.7343C162.833 11.7343 164.141 13.2846 164.141 16.3649V24.0995H161.832V16.8907C161.832 15.1945 161.477 13.8579 159.55 13.8579C157.717 13.8579 156.243 15.0758 155.742 16.816C155.6 17.2944 155.553 17.8439 155.553 18.441V24.0961H153.247V12.0226Z'
          fill={color || '#015F94'}
        />
        <path
          d='M172.777 11.7343C176.179 11.7343 177.988 14.265 177.988 17.3928C177.988 17.7015 177.917 18.3969 177.917 18.3969H169.139C169.257 21.0464 171.137 22.383 173.278 22.383C175.347 22.383 176.845 20.9751 176.845 20.9751L177.795 22.6713C177.795 22.6713 176.01 24.3913 173.132 24.3913C169.349 24.3913 166.755 21.6468 166.755 18.0644C166.759 14.2175 169.352 11.7343 172.777 11.7343ZM175.631 16.6498C175.56 14.5737 174.275 13.5695 172.73 13.5695C170.968 13.5695 169.541 14.6687 169.21 16.6498H175.631Z'
          fill={color || '#015F94'}
        />
        <path
          d='M180.013 26.6032C180.013 26.6032 180.679 27.1052 181.417 27.1052C182.343 27.1052 183.131 26.4369 183.581 25.3378L184.176 23.9537L179.131 12.0193H181.724L184.747 19.9202C184.984 20.541 185.2 21.3755 185.2 21.3755H185.248C185.248 21.3755 185.437 20.5647 185.653 19.9439L188.578 12.0193H191.077L185.44 26.2673C184.703 28.1297 183.229 29.1067 181.538 29.1067C180.182 29.1067 179.205 28.3672 179.205 28.3672L180.013 26.6032Z'
          fill={color || '#015F94'}
        />
        <path
          d='M6.95532 6.44214L12.876 8.75575L24.2777 4.39653L36.0175 8.72182L41.9348 6.47606L24.0782 0L6.95532 6.44214Z'
          fill={color || '#3992C6'}
        />
        <path
          d='M5.34924 7.41577V11.9446L24.2101 19.0584L43.5748 11.8768L43.4395 7.44969L24.3454 14.4957L5.34924 7.41577Z'
          fill={color || '#009FD3'}
        />
        <path
          d='M0 15.9036V20.4324L18.8609 27.5462L38.2221 20.3646L38.0903 15.9375L18.9961 22.9835L0 15.9036Z'
          fill={color || '#EC9F24'}
        />
        <path
          d='M5.4845 24.3573V28.8861L24.3454 36L43.7066 28.8217L43.5748 24.3912L24.4806 31.4372L5.4845 24.3573Z'
          fill={color || '#015F94'}
        />
        <path
          d='M1.52161 14.896L5.43376 13.4882L11.2868 15.8018L7.47268 17.3283L1.52161 14.896Z'
          fill={color || '#EC9F24'}
        />
        <path
          d='M41.8841 23.4923L37.9719 22.0811L32.1189 24.3981L35.933 25.9246L41.8841 23.4923Z'
          fill={color || '#005980'}
        />
      </g>
    </svg>
  );
};

export default CJIcon;
